import { render, staticRenderFns } from "./workflow-access-table.vue?vue&type=template&id=080e3a8c"
import script from "./workflow-access-table.vue?vue&type=script&lang=js"
export * from "./workflow-access-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports